import { createSlice } from "@reduxjs/toolkit";
import { BULK_UPLOAD_MEMBER } from "../../../state";

const bulkUploadMemberSlice = createSlice({
  name: "BULK_UPLOAD_MEMBER_SLICE",
  initialState: BULK_UPLOAD_MEMBER,
  reducers: {
    startBulkUploadMember: (state) => {
      state.bulkUploadLoading = true;
      state.bulkUploadError = null;
    },
    successBulkUploadMember: (state, action) => {
      state.bulkUploadLoading = false;
      state.finalStatus = action.payload;
    },
    errorBulkUploadMember: (state, action) => {
      state.bulkUploadLoading = false;
      state.bulkUploadError = action.payload;
    },
  },
});

export const {
  startBulkUploadMember,
  successBulkUploadMember,
  errorBulkUploadMember,
} = bulkUploadMemberSlice.actions;

export const uploadBulkMemberReducer = bulkUploadMemberSlice.reducer;
